import { Routes, Route, Navigate } from 'react-router-dom';
import { getAccessToken } from './lib/api';
import LoginPage from './pages/LoginPage';
import CallbackPage from './pages/CallbackPage';
import RoleRouter from './components/RoleRouter';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  if (!getAccessToken()) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/callback" element={<CallbackPage />} />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <RoleRouter />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}
